var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResultTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_4168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.754 2.24254L9.20635 4.4385C9.3215 5.0101 8.95551 5.56937 8.3839 5.68451C7.81229 5.79966 7.25303 5.43367 7.13788 4.86206L6.68553 2.66611C6.57039 2.0945 6.93638 1.53523 7.50799 1.42009C8.07959 1.30495 8.63886 1.67094 8.754 2.24254Z",
    fill: "#4674B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8568 2.08618L6.53336 2.5632C6.10569 2.64956 5.68624 2.37404 5.59988 1.94636C5.51352 1.51868 5.78904 1.09923 6.21672 1.01288L8.54426 0.535852C8.97194 0.449494 9.39139 0.725016 9.47775 1.15269C9.56411 1.58037 9.28858 1.99982 8.8568 2.08618Z",
    fill: "#4F95CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2466 12.042C16.2466 15.4881 13.442 18.2885 10 18.2885C6.55805 18.2885 3.75348 15.484 3.75348 12.042C3.75348 8.60413 6.55805 5.79956 10 5.79956C13.442 5.79956 16.2466 8.60413 16.2466 12.042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.59961C5.34081 3.59961 1.55341 7.39112 1.55341 12.0421C1.55341 16.7013 5.34492 20.4887 10 20.4887C14.6551 20.4887 18.4466 16.6972 18.4466 12.0421C18.4466 7.39112 14.6592 3.59961 10 3.59961ZM10 18.2886C6.55393 18.2886 3.75347 15.4841 3.75347 12.0421C3.75347 8.60424 6.55804 5.79967 10 5.79967C13.442 5.79967 16.2465 8.60424 16.2465 12.0421C16.2465 15.4882 13.4461 18.2886 10 18.2886Z",
    fill: "#4F95CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2813 11.2148H13.6797C14.0977 11.2148 14.4336 11.5547 14.4336 11.9688C14.4336 12.3867 14.0938 12.7227 13.6797 12.7227H10.2813C9.86328 12.7227 9.52734 12.3828 9.52734 11.9688C9.52734 11.5547 9.86719 11.2148 10.2813 11.2148Z",
    fill: "#373737",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0352 13.4844C10.8161 13.4844 11.4492 12.8076 11.4492 11.9727C11.4492 11.1378 10.8161 10.4609 10.0352 10.4609C9.25419 10.4609 8.62109 11.1378 8.62109 11.9727C8.62109 12.8076 9.25419 13.4844 10.0352 13.4844Z",
    fill: "#373737",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_4168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultTime);
export default __webpack_public_path__ + "static/media/result_time.9dd61f29d4e59545b9716ebc2efeefa1.svg";
export { ForwardRef as ReactComponent };